<template>
    <div>
        user
    </div>
</template>

<script setup name="user">
    
</script>